import { useLocation } from "wouter";
import QuoteCarousel from "@/components/QuoteCarousel";
import { LogoMark } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { CheckCircle } from "lucide-react";

const TYPE_LABELS: Record<string, string> = {
  queued: "queue status",
  rejected: "rejection status",
  payment_sent: "payment sent",
  debt_cleared: "debt cleared",
  donor_updates: "donor update",
  verification_results: "verification result",
};

function getTypeLabel(type: string | null): string {
  if (!type) return "verification result";
  return TYPE_LABELS[type] ?? "notification";
}

export default function Unsubscribed() {
  const [, navigate] = useLocation();
  const params = new URLSearchParams(window.location.search);
  const type = params.get("type");
  const label = getTypeLabel(type);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background px-4">
      <div className="max-w-md w-full text-center space-y-6">
        <div className="flex justify-center">
          <LogoMark size={48} />
        </div>
        <div className="flex justify-center">
          <CheckCircle className="h-16 w-16 text-green-500" />
        </div>
        <h1 className="text-2xl font-bold">You've been unsubscribed</h1>
        <p className="text-muted-foreground">
          You will no longer receive <strong>{label}</strong> emails from DebtBridge. You can
          re-enable them at any time from the Notification Preferences section in your
          dashboard.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center pt-2">
          <Button variant="outline" onClick={() => navigate("/")}>
            Back to Home
          </Button>
          <Button onClick={() => navigate("/debtor")}>
            Go to My Dashboard
          </Button>
        </div>
      </div>
      <QuoteCarousel />

    </div>
  );
}
